export default "__VITE_ASSET__BfHeB_dF__"